module.exports = __webpack_public_path__ + "StockImagery2024_Device_Backside_3x2_ClearSpace_LeftSide_V1.6875208cdf64b1371996541801e4b8b4.jpg";